<template>
  <div class="register-page">
  <div class="user-auth-container">
    <div class="auth-sky" aria-hidden="true"></div>
    <div class="auth-stars" aria-hidden="true"></div>
    <div class="auth-vignette" aria-hidden="true"></div>

    <div class="auth-wrap">
      <div class="auth-topbar">
        <div class="brand">
          <div class="brand-block"></div>
          <div class="brand-text">
            <div class="brand-title">云边小镇</div>
            <div class="brand-subtitle">REGISTER</div>
          </div>
        </div>
        <a class="back-home" href="/index">返回首页</a>
      </div>

      <div class="auth-card">
        <div class="title">注册新玩家</div>

        <div class="row">
          <label class="label">游戏昵称（不可中文）</label>
          <input class="mc-input" v-model.trim="nickname" @blur="validateNickname" @keyup.enter="register" placeholder="游戏中的英文名，注册完成以后昵称不可修改！" />
          <div class="hint" v-if="nicknameHint">{{ nicknameHint }}</div>
        </div>

        <div class="row">
          <label class="label">邮箱</label>
          <input class="mc-input" v-model.trim="email" @blur="validateEmail" @keyup.enter="register" placeholder="请输入邮箱" />
          <div class="hint" v-if="emailHint">{{ emailHint }}</div>
        </div>

        <div class="row code-row">
          <div class="code-left">
            <label class="label">邮箱验证码</label>
            <input class="mc-input" v-model.trim="emailCode" @keyup.enter="register" placeholder="请输入邮箱验证码" />
          </div>
          <button class="mc-btn mc-btn-primary code-send" type="button" @click="sendRegisterCode" :disabled="sending || countdown > 0 || !email">
            {{ sending ? '发送中...' : countdown > 0 ? `${countdown}s` : '发送验证码' }}
          </button>
        </div>

        <div class="row">
          <label class="label">密码（至少8位）</label>
          <input class="mc-input" v-model.trim="password" @blur="validatePassword" type="password" @keyup.enter="register" placeholder="请输入密码" />
          <div class="hint" v-if="passwordHint">{{ passwordHint }}</div>
        </div>

        <div class="row">
          <label class="label">确认密码</label>
          <input class="mc-input" v-model.trim="confirmPassword" @blur="validateConfirmPassword" type="password" @keyup.enter="register" placeholder="请再次输入密码" />
          <div class="hint" v-if="confirmPasswordHint">{{ confirmPasswordHint }}</div>
        </div>

        <div class="row">
          <label class="label">说明（最多200字）</label>
          <textarea class="mc-input" rows="3" v-model.trim="bio" @blur="validateBio" placeholder="本注册只接纳小镇成员，非小镇成员不可注册！在小镇中圈地建立住所，即可成为小镇成员！此处说明填写自我介绍，同时也要说明家的具体位置，可以是坐标，我会上线查看，确认无误，账号才可以被通过。"></textarea>
          <div class="bio-counter" :class="{ error: bio.length > 200 }">{{ bio.length }}/200</div>
          <div class="hint" v-if="bioHint">{{ bioHint }}</div>
        </div>

        <div class="row terms-row">
          <label class="terms-check">
            <input type="checkbox" v-model="agreeTerms" />
            <span class="terms-checkmark"></span>
            <span class="terms-label">我已阅读并同意《用户条例》</span>
            <button type="button" class="terms-view-btn" @click="showTermsModal = true">查看条例</button>
          </label>
          <div v-if="termsHint" class="hint terms-hint" :class="{ shake: termsShake }">{{ termsHint }}</div>
        </div>

        <div class="row" style="margin-top: 28px;">
          <button class="mc-btn mc-btn-primary" @click="register" :disabled="loading">{{ loading ? '注册中...' : '注册' }}</button>
        </div>

        <div class="row actions">
          <a class="link" href="/login">返回登录</a>
        </div>

        <div v-if="error" class="error">{{ error }}</div>
        <div v-if="ok" class="ok">{{ ok }}</div>
      </div>

      <div class="auth-ground" aria-hidden="true">
        <div class="grass"></div>
        <div class="dirt"></div>
      </div>
    </div>

    <Transition name="terms-modal">
      <div v-if="showTermsModal" class="terms-modal" @click.self="closeTermsModal">
        <div class="terms-modal-inner">
          <div class="terms-modal-header">
            <div class="terms-modal-title">用户条例</div>
            <button type="button" class="terms-modal-close" @click="closeTermsModal">×</button>
          </div>
          <div class="terms-modal-body">
            <div class="terms-modal-desc">欢迎加入云边小镇。在注册与使用过程中，请遵守以下条款：</div>
            <div class="terms-list">
              <div class="terms-item">1. 禁止发布涉黄、涉赌、涉毒等违法内容。</div>
              <div class="terms-item">2. 禁止发布违法犯罪、暴力、恐怖主义相关内容。</div>
              <div class="terms-item">3. 禁止发布诱导转账、诈骗、虚假宣传等内容。</div>
              <div class="terms-item">4. 禁止发布个人隐私信息，如手机号、微信号、QQ号等。</div>
              <div class="terms-item">5. 请文明交流，尊重他人，遵守社区规范。</div>
              <div class="terms-item">6. 违反条例的账号将被封禁或清理，有违法犯罪行为将上报公安部门。</div>
            </div>
            <div class="terms-modal-desc" style="margin-top: 14px;">请仔细阅读并确认同意以上条款后再进行注册。</div>
          </div>
          <div class="terms-modal-footer">
            <button type="button" class="mc-btn" @click="closeTermsModal">我已知晓</button>
          </div>
        </div>
      </div>
    </Transition>
  </div>
  </div>
</template>

<script>
import { ref, onUnmounted } from 'vue'

import { API_BASE } from '../config/apiBase'

// API_BASE moved to @/config/apiBase


export default {
  name: 'RegisterPage',
  setup() {
    const nickname = ref('')
    const email = ref('')
    const emailCode = ref('')
    const password = ref('')
    const confirmPassword = ref('')
    const bio = ref('')


    const nicknameHint = ref('')
    const emailHint = ref('')
    const passwordHint = ref('')
    const confirmPasswordHint = ref('')
    const bioHint = ref('')

    const error = ref('')
    const ok = ref('')
    const loading = ref(false)

    const checkingNickname = ref(false)
    const checkingEmail = ref(false)

    const sending = ref(false)
    const countdown = ref(0)
    let timer = null

    const isEmail = (v) => /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/.test(v || '')
    const isNick = (v) => /^[A-Za-z0-9_]{3,16}$/.test(v || '')

    const validateNickname = async () => {
      if (!nickname.value) {
        nicknameHint.value = '请输入游戏昵称'
        return false
      }
      if (!isNick(nickname.value)) {
        nicknameHint.value = '昵称仅英文/数字/下划线，3-16位'
        return false
      }

      checkingNickname.value = true
      try {
        const res = await fetch(`${API_BASE}/user-auth/check-nickname?nickname=${encodeURIComponent(nickname.value)}`)
        const data = await res.json()
        if (data && data.code === 200) {
          if (data.exists) {
            nicknameHint.value = '昵称已存在'
            return false
          }
        }
      } catch (e) {
        // ignore: 网络异常不阻塞输入
      } finally {
        checkingNickname.value = false
      }

      nicknameHint.value = ''
      return true
    }

    const validateEmail = async () => {
      if (!email.value) {
        emailHint.value = '请输入邮箱'
        return false
      }
      if (!isEmail(email.value)) {
        emailHint.value = '邮箱格式不正确'
        return false
      }

      checkingEmail.value = true
      try {
        const res = await fetch(`${API_BASE}/user-auth/check-email?email=${encodeURIComponent(email.value)}`)
        const data = await res.json()
        if (data && data.code === 200) {
          if (data.exists) {
            emailHint.value = '邮箱已存在'
            return false
          }
        }
      } catch (e) {
        // ignore: 网络异常不阻塞输入
      } finally {
        checkingEmail.value = false
      }

      emailHint.value = ''
      return true
    }

    const validatePassword = () => {
      if (!password.value) {
        passwordHint.value = '请输入密码'
        return false
      }
      if (password.value.length < 8) {
        passwordHint.value = '密码至少8位'
        return false
      }
      passwordHint.value = ''
      return true
    }

    const validateConfirmPassword = () => {
      if (!confirmPassword.value) {
        confirmPasswordHint.value = '请再次输入密码'
        return false
      }
      if (confirmPassword.value !== password.value) {
        confirmPasswordHint.value = '两次输入的密码不一致'
        return false
      }
      confirmPasswordHint.value = ''
      return true
    }

    const validateBio = () => {
      if ((bio.value || '').length > 200) {
        bioHint.value = '说明最多200字'
        return false
      }
      bioHint.value = ''
      return true
    }


    const startCountdown = () => {
      countdown.value = 60
      if (timer) clearInterval(timer)
      timer = setInterval(() => {
        countdown.value -= 1
        if (countdown.value <= 0) {
          clearInterval(timer)
          timer = null
        }
      }, 1000)
    }

    const sendRegisterCode = async () => {
      error.value = ''
      ok.value = ''
      const valid = await validateEmail()
      if (!valid) return
      if (countdown.value > 0) return
      sending.value = true
      try {
        const res = await fetch(`${API_BASE}/user-auth/sendEmailCode`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email.value, scene: 'register' })
        })
        const data = await res.json()
        if (data && data.code === 200) {
          startCountdown()
          ok.value = '验证码已发送，请查收邮箱'
        } else {
          error.value = (data && data.message) || '发送失败'
        }
      } catch (e) {
        error.value = '发送失败'
      } finally {
        sending.value = false
      }
    }

    const agreeTerms = ref(false)
    const showTermsModal = ref(false)
    const termsHint = ref('')

    const closeTermsModal = () => {
      showTermsModal.value = false
    }
    const termsShake = ref(false)
    

    const triggerTermsShake = () => {
      termsShake.value = false
      // 触发 reflow 以便重复播放动画
      void document.body.offsetHeight
      termsShake.value = true
      setTimeout(() => {
        termsShake.value = false
      }, 520)
    }

    const validateTerms = () => {
      if (agreeTerms.value) {
        termsHint.value = ''
        return true
      }
      termsHint.value = '请先阅读并勾选用户条例，否则无法注册'
      triggerTermsShake()
      return false
    }

    const register = async () => {
      error.value = ''
      ok.value = ''
      const v1 = validateNickname()
      const v2 = validateEmail()
      const v3 = validatePassword()
      const v4 = validateConfirmPassword()
      const v5 = validateBio()
      const v6 = validateTerms()
      if (!v1 || !v2 || !v3 || !v4 || !v5 || !v6) return
      if (!emailCode.value) {
        error.value = '请输入邮箱验证码'
        return
      }

      loading.value = true
      try {
        const res = await fetch(`${API_BASE}/user-auth/register`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            nickname: nickname.value,
            email: email.value,
            emailCode: emailCode.value,
            password: password.value,
            confirmPassword: confirmPassword.value,
            bio: bio.value,
          })
        })
        const data = await res.json()
        if (data && data.code === 200) {
          ok.value = data.message || '注册成功，请等待管理员审批'
        } else {
          error.value = (data && data.message) || '注册失败'
        }
      } catch (e) {
        error.value = '注册失败'
      } finally {
        loading.value = false
      }
    }

    onUnmounted(() => {
      if (timer) clearInterval(timer)
    })

    return {
      nickname,
      email,
      emailCode,
      password,
      confirmPassword,
      bio,
      nicknameHint,
      emailHint,
      passwordHint,
      confirmPasswordHint,
      bioHint,
      agreeTerms,
      showTermsModal,
      termsHint,
      termsShake,
      closeTermsModal,
      error,
      ok,
      loading,
      sending,
      countdown,
      checkingNickname,
      checkingEmail,
      validateNickname,
      validateEmail,
      validatePassword,
      validateConfirmPassword,
      validateBio,
      sendRegisterCode,
      register
    }
  }

}
</script>

<style>
@import '../styles/auth-mc.css';

/* 注册页卡片化布局 - 仅影响本页面 */
.register-page .user-auth-container {
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 100vh;
}

.register-page .auth-wrap {
  width: 100%;
  max-width: 720px;
  min-height: auto;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-page .auth-topbar {
  display: none;
}

.register-page .auth-card {
  background: rgba(0, 0, 0, 0.94);
  border: 8px solid #5a5a5a;
  border-radius: 12px;
  padding: 60px 50px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.9), inset 0 0 0 2px rgba(255, 255, 255, 0.05);
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.register-page .auth-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 8px;
  background: linear-gradient(90deg, var(--mc-green) 0%, #9ae054 50%, var(--mc-green) 100%);
  border-bottom: 3px solid #3c6b10;
}

.register-page .auth-card::after {
  content: '';
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
}

.register-page .auth-ground {
  display: none;
}

.register-page .title {
  text-align: center;
  font-size: 32px;
  color: #fff;
  text-shadow: 5px 5px 0 #000;
  margin-bottom: 36px;
  letter-spacing: 2px;
}

/* 主按钮：居中拉长，适配卡片 */
.register-page .auth-card .mc-btn.mc-btn-primary {
  display: block;
  width: min(420px, 100%);
  margin: 0 auto;
  padding: 14px 18px;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 2px;
}

/* 邮箱验证码发送按钮：保持在右侧，不被“主按钮”样式影响 */
.register-page .auth-card .mc-btn.mc-btn-primary.code-send {
  width: auto;
  margin: 0;
  padding: 12px 16px;
  font-size: 12px;
  letter-spacing: 1px;
}

/* 操作链接 */
.register-page .actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid rgba(255,255,255,0.1);
}

.register-page .link {
  color: var(--mc-green);
  text-decoration: none;
  font-size: 14px;
  font-weight: 800;
  padding: 6px 10px;
  transition: color 0.2s ease;
}

.register-page .link:hover {
  color: #9ae054;
}

/* 错误/成功提示 */
.register-page .error {
  background: rgba(231, 76, 60, 0.1);
  border: 2px solid #e74c3c;
  color: #e74c3c;
  padding: 12px;
  border-radius: 4px;
  font-size: 12px;
  margin-top: 16px;
  text-align: center;
}

/* 说明字数统计 */
.bio-counter {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(255,255,255,0.75);
  text-align: right;
  text-shadow: 1px 1px 0 #000;
}

.bio-counter.error {
  color: #ff6b6b;
}

.register-page .ok {
  background: rgba(154, 224, 84, 0.1);
  border: 2px solid #9ae054;
  color: #9ae054;
  padding: 12px;
  border-radius: 4px;
  font-size: 12px;
  margin-top: 16px;
  text-align: center;
}

/* 用户条例勾选框 */
.terms-row {
  margin-top: 20px;
  margin-bottom: 12px;
}

.terms-check {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
}

.terms-check input[type="checkbox"] {
  display: none;
}

.terms-checkmark {
  width: 20px;
  height: 20px;
  border: 4px solid #fff;
  background: rgba(0,0,0,0.45);
  box-shadow: inset -3px -3px 0 rgba(0,0,0,0.35), inset 3px 3px 0 rgba(255,255,255,0.06);
  position: relative;
  flex: 0 0 auto;
  transition: background 0.2s;
}

.terms-check input:checked + .terms-checkmark {
  background: var(--mc-green);
}

.terms-checkmark::after {
  content: '';
  position: absolute;
  display: none;
  left: 4px;
  top: 0;
  width: 6px;
  height: 12px;
  border: solid #fff;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.terms-check input:checked + .terms-checkmark::after {
  display: block;
}

.terms-label {
  font-size: 14px;
  color: #fff;
  text-shadow: 2px 2px 0 #000;
}

.terms-view-btn {
  font-size: 12px;
  color: #3cff2f;
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 6px;
  text-shadow: 2px 2px 0 #000;
}

.terms-view-btn:hover {
  color: #9ae054;
}

.terms-hint {
  color: #e74c3c;
  font-size: 12px;
  margin-top: 8px;
}

/* 抖动动画 */
.shake {
  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
}

@keyframes shake {
  10%, 90% { transform: translate3d(-1px, 0, 0); }
  20%, 80% { transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
  40%, 60% { transform: translate3d(4px, 0, 0); }
}

/* 条例弹窗 */
.terms-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.75);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

/* 打开/关闭过渡（丝滑） */
.terms-modal-enter-active,
.terms-modal-leave-active {
  transition: opacity 0.22s ease;
}

.terms-modal-enter-from,
.terms-modal-leave-to {
  opacity: 0;
}

.terms-modal-enter-active .terms-modal-inner,
.terms-modal-leave-active .terms-modal-inner {
  transition: transform 0.26s cubic-bezier(0.18, 0.89, 0.32, 1.28), filter 0.26s ease;
}

.terms-modal-enter-from .terms-modal-inner {
  transform: translateY(12px) scale(0.92);
  filter: blur(6px);
}

.terms-modal-leave-to .terms-modal-inner {
  transform: translateY(10px) scale(0.94);
  filter: blur(6px);
}

.terms-modal-inner {
  max-width: 500px;
  width: 100%;
  background: #111;
  border: 6px solid #000;
  box-shadow: 0 0 0 2px rgba(255,255,255,0.08), 0 0 30px rgba(0,0,0,0.9);
}

.terms-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 4px solid #000;
  background: linear-gradient(90deg, #2f7d1b 0 25%, #3e8f27 25% 50%, #2f7d1b 50% 75%, #3e8f27 75% 100%);
}

.terms-modal-title {
  font-size: 16px;
  color: #fff;
  text-shadow: 2px 2px 0 #000;
}

.terms-modal-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  text-shadow: 2px 2px 0 #000;
  padding: 0 4px;
}

.terms-modal-body {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #5ea818 #111;
}

.terms-modal-body::-webkit-scrollbar {
  width: 12px;
}
.terms-modal-body::-webkit-scrollbar-track {
  background: #111;
}
.terms-modal-body::-webkit-scrollbar-thumb {
  background: #5ea818;
  border: 2px solid #000;
}

.terms-modal-desc {
  font-size: 13px;
  color: #d1e8b9;
  text-shadow: 1px 1px 0 #000;
  line-height: 1.8;
  margin-bottom: 14px;
}

.terms-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 14px;
}

.terms-item {
  font-size: 13px;
  color: #fff;
  text-shadow: 1px 1px 0 #000;
  line-height: 1.8;
  padding-left: 8px;
  border-left: 3px solid var(--mc-green);
}

.terms-modal-footer {
  padding: 16px 20px;
  border-top: 4px solid #000;
  text-align: center;
}

/* 响应式 */
@media (max-width: 768px) {
  .register-page .user-auth-container {
    padding: 20px 15px;
  }

  .register-page .auth-card {
    padding: 40px 30px;
  }

  .register-page .title {
    font-size: 28px;
  }

  .terms-modal {
    padding: 10px;
  }

  .terms-modal-inner {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .register-page .user-auth-container {
    padding: 15px 10px;
  }

  .register-page .auth-card {
    padding: 30px 20px;
  }

  .register-page .title {
    font-size: 24px;
  }

  .terms-modal-body {
    max-height: 70vh;
  }
}
</style>

